module.exports = __webpack_public_path__ + "static/Customize-f64d544fc69073950ec51b43a306357c.png";